module.exports = "/_next/static/images/OneAudience-b20fe866b77a0c65a27b1c8192563dff.webp";